export default {
  latestRoute: null,
  columns: {},
  search: '',
  specialIdSearch: '',
  selectedRowSpacingOption: 'compact-view',
  totalRowsCount: 0,
  operatorsList: [],

  eventListFilterModifiers: {
    date: [
      {
        value: 'equalTo',
        label: 'Is',
      },
      {
        value: 'greaterThan',
        label: 'After',
      },
      {
        value: 'lessThan',
        label: 'Before',
      },
    ],
    select: [
      {
        value: 'in',
        label: 'Is',
      },
      {
        value: 'notEqualToInsensitive',
        label: 'Is not',
      },
    ],
  },
  previousEventListOptions: '',
  eventList: [],
  eventListLoading: false,
  specialList: [],
  specialListLoading: false,
  userList: [],
  userListLoading: false,
  userAuditLog: [],
  userAuditLogLoading: false,
  suspensionInProgressSpecialIds: [],
  bookedEventsInSession: [],
  bookedEvents: [],
  selectedEvents: [],
  selectedMarkets: [],
  isEventsSidebarActive: false,
  isEventsFiltersActive: true,

  sidebar: {
    expanded: true,
    loading: false,
    sports: [],
    regions: [],
    competitions: [],
    selection: {
      sportId: null,
      regionId: null,
      competitionId: null,
      subscribed: null,
    },
  },
  subscriptionModal: {
    open: false,
    type: '',
    id: '',
  },
  bulkSubscriptionModal: {
    open: false,
  },

  event: null,
  eventLoading: false,
  eventMarkets: null,
  eventMarketsLoading: false,
  eventTeamPlayers: {
    home: [],
    away: [],
  },

  marketTemplate: {
    selectedSport: '',
    selectedRegion: '',
  },
  sportTemplates: [],
  competitionTemplateChanged: false,
  userToken: null,
  authReady: false,
  username: '',
  userRoles: [],
  operator: '',
  loginErrorMessage: '',
  socketConnection: null,
  changePasswordAttributes: null,

  allFeeds: [],

  notifications: [],
  suspensionInProgressEventIds: [],
  suspendMarketTypeActionLoading: false,
  eventListMappingEvent: null,

  marketGroups: [],
  marketFavorites: [],

  mapping: {
    initialized: false,
    loading: false,
    sports: [],
    entries: [],

    selectedSportId: '',
    selectedSportLabel: '',

    selectedFeed: 'huddle',
    primaryFeeds: [],
    secondaryFeeds: [],
    feedsPerSport: [],
    displayedFeeds: [],

    searchOptions: [
      {
        label: 'name',
        value: 'name',
      },
      {
        label: 'ID',
        value: 'id',
      },
    ],
    selectedSearchOption: 'name',
    searchQuery: '',

    selectedDisplay: ['mapped', 'not-mapped'],
    displayOptions: [
      {
        id: 'mapped',
        label: 'Mapped',
      },
      {
        id: 'not-mapped',
        label: 'Not mapped',
      },
    ],

    selectedDate: 7,
    dateOptions: [
      {
        label: 'Last month',
        value: -30,
      },
      {
        label: 'Last 7 days',
        value: -7,
      },
      {
        label: 'Last 3 days',
        value: -3,
      },
      {
        label: 'Yesterday',
        value: -1,
      },
      {
        label: 'Today',
        value: 0,
      },
      {
        label: 'Incoming 2 hours',
        value: 0.2,
      },
      {
        label: 'Incoming 3 days',
        value: 3,
      },
      {
        label: 'Incoming 7 days',
        value: 7,
      },
      {
        label: 'Next month',
        value: 30,
      },
      {
        label: 'Next 3 months',
        value: 90,
      },
    ],
  },
  eventSuggestedMappings: [],
  competitorSuggestedMappings: [],
  regionSuggestedMappings: [],
  competitionSuggestedMappings: [],
  playerSuggestedMappings: [],

  manualResultingEvent: null,
  manualResultingEventLoading: false,
  manualResultingEvents: [],
  manualResultingEventMarkets: {},
  manualResultingEventMarketsLoading: false,
  manualResultingSelectedMarkets: [],
  manualEventState: null,
  manualEventStateLoading: false,

  // Player setup
  playerSetupOriginalTableData: {},
  playerSetupTableData: null,
  playerParamsPrematchTableData: null,
  playerSetupData: null,
  isPlayerSetupDataLoading: {},
  isPlayerSetupProjectionsAvailable: false,
  // Paramfinding data
  eventParamfindingData: null,
  playerParamfindingData: null,
  isParamfindingDataLoading: false,
  isPlayerSetupScoreboardActive: false,
  playerSetupEventSearchActive: false,
  playerSetupEventList: [],
  playerSetupEventListLoading: false,
  teamSquadListLoading: false,
  isPlayerSetupSubmitEnabled: false,
  isPlayerSetupSubmitLoading: false,
  isPlayerSetupSimulateEnabled: false,
  isPlayerSetupSimulateBySocketChangeEnabled: false,
  isPlayerSetupPageFrozen: false,
  frozenPlayerSetupPageMessage: '',
  isPlayerSetupSimulateBtnFrozen: false,
  numberOfSimulateAttempts: 0,
  availableMarkets: {},
  availableComboMarkets: {},
  isMarketsLoading: {},
  playersForMarketsPopupList: [],
  highlightedPlayer: null,
  playerSetupInferActive: false,
  playerSetupBeforeInferState: null,
  playerParamsSelectedMode: '',
  playerParamsLastSubmittedSelectedMode: '',
  paramsManagerMarkets: {
    currentGameMarkets: [],
    simulatedGameMarkets: [],
  },
  paramsManagerMarketsBeforeInferState: null,
  isInferModalOpen: false,
  lastInferInfo: { status: 'N_A' },
  inferInfoByEventId: {},
  inferAvailable: false,
  inferAvailableMarkets: null,
  lineupPresetsByTeam: {},
  selectedLineupPresetByTeam: {},
  playerSetupMappedPlayersForProjections: [],
  paramsManagerSquadData: [],
  paramsManagerEventSuspendLoading: false,
  availableMarketsPlayerTypes: {},
  playerSetupUnpublishedChanges: false,
  playerSuspendToggleDisabled: false,
  paramsManagerAvailableGameMarkets: [],

  // Game params
  playerSetupGameParams: null,
  playerSetupPrematchGameParams: {},
  gameParamsSelectedMode: '',
  gameParamsLastSubmittedSelectedMode: '',
  paramsManagerGameProjectionsAvailable: '',
  allBaseballParks: [],
  gameParamsSelectedMarkets: null,
  gameParamsSelectedMarketsProcessing: false,
  isPrematchParamsPreviewActive: {},
  riskFlagsOverride: null,
  isEventStaleCheckEnabled: {
    originalValue: true,
    currentValue: true,
  },

  // Trading UI
  tradingEvent: null,
  tradingEventLoading: false,
  originalTradingPlayerProps: [],
  lastSimulateTradingPlayerProps: [],
  tradingPlayerProps: null,
  isSimulateBtnEnabled: false,
  isSimulateBtnLoading: false,
  isPublishBtnEnabled: false,
  isPublishBtnLoading: false,
  publishDisabledHintMessage: null,
  tradingPlayerPropsLoading: false,
  tradingEventSearchActive: false,
  tradingEventList: [],
  tradingEventListLoading: false,
  tradingEventMarkets: {},
  tradingEventSuspendLoading: false,
  selectedTradingMarkets: [],
  isTradingUIPageFrozen: false,
  isTradingUISimulateBtnFrozen: false,
  isUnsavedChangesActive: false,
  tradingSquad: [],
  tradingGameParamsLoading: false,
  tradingEventFeeds: [],
  tradingEventSelectedFeed: null,
  tradingSimulateBySocketChangeEnabled: false,

  oddFormats: [ // Will move this to CMS config when implemented
    {
      id: 'AMERICAN',
      name: 'american',
      label: 'American',
    },
    {
      id: 'DECIMAL',
      name: 'decimal',
      label: 'Decimal',
    },
    {
      id: 'FRACTIONAL',
      name: 'fractional',
      label: 'Fractional',
    },
    {
      id: 'PROBABILITY',
      name: 'probability',
      label: 'Probability',
    },
  ],
  selectedOddFormat: {
    id: 'AMERICAN',
    name: 'american',
    label: 'American',
  },

  // Manual edit
  manualEditTableColumns: null,
  manualEditTableData: [],
  manualEditDataLoading: false,
  manualEditSelectedSport: '',
  manualEditSelectedRow: null,
  manualEditPlayerSearchList: [],
  manualEditPlayerSearchListLoading: false,
  manualEditSearch: '',
  manualEditSelectedFeed: '',
  manualEditIsCreateNewRecordActive: false,
  manualEditTeamsSearchList: [],
  manualEditTeamSearchListLoading: false,

  displayMarketsConfiguration: null,
  allMarketParameters: null,
  // Market group
  marketGroupMarketCodeSearchList: [],
  marketGroupMarketCodeSearchListLoading: false,

  // Multiview
  multiviewList: {
    latestOptions: null,
    loading: false,
    eventsById: {},
    competitionsById: {},
    markets: {},
    paramsLoading: false,
  },
  multiviewDrawer: {
    event: null,
    loading: false,
    processing: false,
  },
  multiviewOriginalPlayerParams: null,
  multiviewPlayerParams: null,
  multiviewPlayerParamsLoading: false,
  multiviewLastSimulatePlayerParams: null,
  multiviewSquad: null,
  multiviewSimulateBtnEnabled: false,
  multiviewSimulateBtnFrozen: false,
  multiviewSimulateBtnLoading: false,
  multiviewSubmitBtnEnabled: false,
  multiviewSubmitBtnLoading: false,
  multiviewDrawerFrozen: false,
  multiviewSimulateBySocketChangeEnabled: false,

  // Odds checker
  oddsCheckerFiltersMeta: {
    sports: [],
    competitions: [],
  },
  oddsCheckerEvents: {},
  oddsCheckerMarkets: {},
  oddsCheckerEventsLoading: false,
  oddsCheckerQueryOptions: {},
  selectedOddsCheckerMarket: null,
  // Audit log
  auditLogEvent: null,
  auditLogEventLoading: false,
  auditLogEventMarkets: {},
  auditLogEventMarketSelectionsUrls: null,
  auditLogMarketHistoryDashboardLoading: false,

  // Market templates
  marketTemplateMarketsScrollPosition: 0,

  competitionsSubscriptionsFilters: {
    subscription: null,
    mapping: null,
  },

  clientSettingsModalOpened: false,

  // User config
  userConfigurationBookmakers: null,
  userConfigurationBetTickerColumns: null,

  socketReconnectedModalActive: false,

  // Competition configuration
  competitionConfigurationList: [],

  // Backoffice metadata
  metadata: {
    marketSelections: {},
  },
};
